var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:person-feedback-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8228 11.9214C14.9514 11.9786 15.0871 12 15.2157 12C15.5085 12 15.7943 11.8786 16.0014 11.6571L17.6728 9.85714H19.8585C21.0371 9.85714 22.0014 8.89286 22.0014 7.71429V4.14286C22.0014 2.96429 21.0371 2 19.8585 2H14.1443C12.9657 2 12.0014 2.96429 12.0014 4.14286V7.70714C12.0014 8.88571 12.9657 9.85 14.1443 9.85V10.9214C14.1443 11.3714 14.4085 11.7571 14.8228 11.9214ZM8.07282 13.4286C6.10139 13.4286 4.50139 11.8286 4.50139 9.85714C4.50139 7.88571 6.10139 6.28571 8.07282 6.28571C10.0442 6.28571 11.6442 7.88571 11.6442 9.85714C11.6442 11.8286 10.0442 13.4286 8.07282 13.4286ZM8.07282 21.9929C6.00139 21.9929 4.41568 21.4214 3.34425 20.3014C1.96496 18.8621 1.99711 17.0264 2.00068 16.8457V16.8336C2.00139 15.7571 2.90139 14.8571 4.01568 14.8571H12.13C13.2371 14.8571 14.1443 15.7564 14.1443 16.8693V16.8764C14.1471 17.0064 14.1871 18.855 12.8014 20.3086C11.73 21.4293 10.1442 22 8.07282 22V21.9929Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.1adc96d341947a62e3decf030563054e.svg";
export { ForwardRef as ReactComponent };